import { render, staticRenderFns } from "./DrugDull.vue?vue&type=template&id=5e717524&scoped=true&"
import script from "./DrugDull.vue?vue&type=script&lang=js&"
export * from "./DrugDull.vue?vue&type=script&lang=js&"
import style0 from "./DrugDull.vue?vue&type=style&index=0&id=5e717524&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e717524",
  null
  
)

export default component.exports